import React, { useState, useEffect } from 'react';

const FilterButton = ({ appointments, setFilteredAppointments, isOpen, setIsOpen, menuRef }) => {
    // const [isOpen, setIsOpen] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState(new Set());

    const toggleMenu = () => setIsOpen(prev => !prev);

    const handleOptionClick = (option) => {
        setSelectedOptions(prev => {
            const updated = new Set(prev);
            if (updated.has(option)) {
                updated.delete(option);
            } else {
                updated.add(option);
            }
            return updated;
        });
    };

    useEffect(() => {
        const filtered = appointments.filter((appt) => {
            const status = appt.status?.toLowerCase();
            const artist = appt.appointmentDetails?.[5]?.artist;
            const date = new Date(appt.appointmentDetails?.[5]?.date);

            let matches = true;

            // Filter by Status
            const statusFilters = ['pending', 'rejected', 'confirmed', 'cancelled'];
            const selectedStatuses = statusFilters.filter(s => selectedOptions.has(capitalize(s)));
            if (selectedStatuses.length > 0 && !selectedStatuses.includes(status)) {
                matches = false;
            }

            // Filter by Nail Tech
            const techFilters = ['Leah', 'Kayla', 'Kelly'];
            const selectedTechs = techFilters.filter(t => selectedOptions.has(t));
            if (selectedTechs.length > 0 && !selectedTechs.includes(artist)) {
                matches = false;
            }

            // Filter by Date (simple string match for now)
            const today = new Date();
            const tomorrow = new Date();
            tomorrow.setDate(today.getDate() + 1);

            const selectedDates = ['Today', 'Tomorrow', 'This week'];
            const matchDate = selectedDates.find(d => selectedOptions.has(d));
            if (matchDate === 'Today' && !isSameDay(today, date)) matches = false;
            if (matchDate === 'Tomorrow' && !isSameDay(tomorrow, date)) matches = false;
            if (matchDate === 'This week' && !isSameWeek(today, date)) matches = false;

            return matches;
        });

        setFilteredAppointments(filtered);
    }, [selectedOptions, appointments, setFilteredAppointments]);

    const isSameDay = (d1, d2) => {
        return (
            d1.getDate() === d2.getDate() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getFullYear() === d2.getFullYear()
        );
    };

    const isSameWeek = (d1, d2) => {
        const startOfWeek = new Date(d1);
        startOfWeek.setDate(d1.getDate() - d1.getDay());
        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);
        return d2 >= startOfWeek && d2 <= endOfWeek;
    };

    const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);

    const renderOption = (label) => (
        <div
            key={label}
            className={`filter-option ${selectedOptions.has(label) ? 'selected' : ''}`}
            onClick={() => handleOptionClick(label)}
        >
            {label}
        </div>
    );

    return (
        <div className="filter-container ScheduleFilter" ref={menuRef}>
            <button className="filter-button" onClick={toggleMenu}>
                <img className="filter-icon" src="/images/Settings.png" alt="Filter Icon" />
            </button>
            {isOpen && (
                <div className="filter-menu schedule-object">
                    {/* <div className="section-title">Status</div>

                    <div className="filter-section">
                        {['Pending', 'Rejected', 'Confirmed', 'Cancelled'].map(renderOption)}
                    </div> */}
                    <div className="section-title">Nail Tech</div>

                    <div className="filter-section">
                        {['Leah', 'Kayla', 'Kelly'].map(renderOption)}
                    </div>
                    {/* <div className="section-title">Date</div>

                    <div className="filter-section">
                        {['Today', 'Tomorrow', 'This week'].map(renderOption)}
                    </div> */}
                </div>
            )}
        </div>
    );
};

export default FilterButton;
